import { createAction } from 'redux-actions';

export const startSignUpSubmit = createAction('START_SIGN_UP_SUBMIT');

export const resolveSignUpSubmit = createAction('RESOLVE_SIGN_UP_SUBMIT');
